import dayjs from 'dayjs';

class ScheduleReportService {
  setTimePicker = (startTimeHours: string, startTimeMinutes: string): dayjs.Dayjs => {
    const currentTime = dayjs();
    let computedTime = currentTime.add(10, 'minutes');
    const currentMinute = computedTime.minute();
    const moduloValue = 5;
    const moduloRest = currentMinute % moduloValue;

    if (startTimeHours && startTimeMinutes) {
      computedTime = dayjs().hour(parseInt(startTimeHours)).minute(parseInt(startTimeMinutes));
    } else if (moduloRest > 0) {
      const minutesToAdd = moduloValue - moduloRest;

      computedTime = computedTime.add(minutesToAdd, 'minutes');
    }

    return computedTime;
  };
}

export default new ScheduleReportService();
